export function isSafari() {
  if (typeof window !== "undefined") {
    if (navigator && navigator.userAgent) {
      let isSafari =
        navigator.userAgent.indexOf("Safari") !== -1 &&
        navigator.userAgent.indexOf("Chrome") === -1;
      return isSafari;
    } else {
      return false;
    }
  }
}
